import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { AppInsightsService } from './_shared/services/appInsights/appInsights.service';
import { Router } from '@angular/router';

/**
 * Handles global errors in the application.
 * <summary>
 * This service captures all unhandled errors, tracks them via Application Insights,
 * and logs them to the console.
 * </summary>
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    // Retrieve the AppInsightsService instance to avoid circular dependency issues
    const appInsights = this.injector.get(AppInsightsService);
    const router = this.injector.get(Router);
    const ngZone = this.injector.get(NgZone);
    
    // Normalize anything to a real Error instance
    const ex =
      error instanceof Error
        ? error
        : new Error(
            typeof error === 'string'
              ? error
              : (error?.message ?? JSON.stringify(error))
          );

    appInsights.trackException(ex);

    // Check for Angular routing error NG04002
    const isRouteError =
      typeof error?.message === 'string' &&
      error.message.includes("NG04002");

    if (isRouteError) {
      // Avoid throwing again — navigate instead
      // TODO: consider sending a query paramater to indicate the error
      ngZone.run(() => {
        router.navigate(['/errors']);
      });
      return;
    }

    // Log to console for development
    console.error(error);
  }
}
